import { useMemo } from 'react';
import IDeal from '@/creditflowresearch/domain/vo/IDeal';
import { ICorporateDeal } from '@/creditflowresearch/domain/vo/Deals/CorporateDeal';
import { getDealGrantContext } from '@/creditflowresearch/application/Deal/helpers/getDealGrantContext';
import { useAccessGrant } from './useAccessGrant';

/**
 * A deal card carries no query string of its own, so the grant is resolved from the deal
 * itself — its markets, regions and product — and a card opened from anywhere (list row,
 * post, direct link) is judged the same way.
 *
 * TODO: remove when the European market opening period ends
 */
export const useDealAccessGrant = (deal?: IDeal | ICorporateDeal): boolean => {
  const grantContext = useMemo(() => ({
    marketIds: [],
    ...getDealGrantContext(deal),
  }), [deal]);

  return useAccessGrant(grantContext);
};
